// import React, { useState, useEffect } from "react";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import type { IFilter } from "../../components/common/CommonFilter";
// import { Eye, Pencil, Plus, Trash2, Upload, MapPin } from "lucide-react"; // added MapPin
// import { showToastNotification } from "../../utility/helper";
// import { Button } from "../../components/ui/button";
// import MainHeading from "../../components/common/MainHeading";
// import CommonFilter from "../../components/common/CommonFilter";
// import CommonTable, {
//   type TableColumn,
// } from "../../components/common/CommonTable";
// import TablePagination from "../../components/common/TablePagination";
// import { RoutesLink } from "../../utility/RouteLinks";
// import { ThrowError } from "../../api/callApi";
// import { WorkerService } from "@/services/Labor/worker";
// import type { IWorker } from "@/interface/worker.model";
// import AsyncSearchSelect, {
//   type IOption,
// } from "@/components/common/AsyncSearchSelect";
// import { loadSiteOptions } from "@/hooks/Selectloaders";
// import type { IPageInfo } from "@/interface/common.interface";
// import RowActionsMenu from "@/components/common/RowActionsMenu";

// const STATUS_OPTIONS = [
//   { label: "All", value: "" },
//   { label: "Active", value: "active" },
//   { label: "Inactive", value: "inactive" },
// ];

// // Shift variants – stable color per shift
// const SHIFT_VARIANTS = [
//   { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500" },
//   { bg: "bg-indigo-50", text: "text-indigo-700", dot: "bg-indigo-500" },
//   { bg: "bg-orange-50", text: "text-orange-700", dot: "bg-orange-500" },
//   { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500" },
//   { bg: "bg-sky-50", text: "text-sky-700", dot: "bg-sky-500" },
// ];

// const getShiftVariant = (key: string) => {
//   let hash = 0;
//   for (let i = 0; i < key.length; i++) {
//     hash = (hash << 5) - hash + key.charCodeAt(i);
//     hash |= 0;
//   }
//   return SHIFT_VARIANTS[Math.abs(hash) % SHIFT_VARIANTS.length];
// };

// const GENDER_STYLES: Record<
//   IWorker["gender"],
//   { label: string; symbol: string; bg: string; text: string }
// > = {
//   male: { label: "Male", symbol: "♂", bg: "bg-indigo-50", text: "text-indigo-600" },
//   female: { label: "Female", symbol: "♀", bg: "bg-pink-50", text: "text-pink-600" },
//   other: { label: "Other", symbol: "⚧", bg: "bg-slate-100", text: "text-slate-600" },
// };

// const Labor: React.FC = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [laborList, setLaborList] = useState<IWorker[]>([]);
//   const [deletingId, setDeletingId] = useState<string | null>(null);

//   const [filter, setFilter] = useState<
//     IFilter & { siteId?: string; shiftId?: string }
//   >({
//     search: "",
//     status: "",
//     siteId: "",
//     shiftId: "",
//   });

//   const [selectedSiteFilter, setSelectedSiteFilter] = useState<IOption | null>(
//     null,
//   );

//   const [paginationData, setPaginationData] = useState<IPageInfo>({
//     currentPage: 1,
//     pageSize: 10,
//     total: 0,
//     totalPages: 0,
//   });

//   // fetch labor
//   const fetchLabor = async (
//     page = paginationData.currentPage,
//     limit = paginationData.pageSize,
//   ) => {
//     setIsLoading(true);
//     try {
//       const response = await WorkerService.getWorkerList({
//         pageIndex: page,
//         pageSize: limit,
//         search: filter.search || undefined,
//         siteId: filter.siteId || undefined,
//         shiftId: filter.shiftId || undefined,
//         status: filter.status || undefined,
//         sort: "createdAt",
//         order: "DESC",
//       });

//       if (response?.success && response.data) {
//         setLaborList(response.data.rows || []);
//         setPaginationData((prev) => ({
//           ...prev,
//           total: response.data.total || 0,
//           totalPages: response.data.totalPages || 0,
//         }));
//       } else {
//         setLaborList([]);
//         showToastNotification(
//           "danger",
//           response?.message || "Failed to load workers",
//         );
//       }
//     } catch (error) {
//       ThrowError(error);
//       setLaborList([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLabor(paginationData.currentPage, paginationData.pageSize);
//   }, [paginationData.currentPage, paginationData.pageSize, filter]);

//   const handleSearchChange = (value: string) => {
//     setFilter((prev) => ({ ...prev, search: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleFilterChange = (value: string, name: string) => {
//     setFilter((prev) => ({ ...prev, [name]: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleSiteFilterChange = (option: IOption | null) => {
//     setSelectedSiteFilter(option);
//     setFilter((prev) => ({ ...prev, siteId: option?.value ?? "" }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleChangePageSize = (value: number) => {
//     setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
//   };

//   const handleDelete = async (workerId: string) => {
//     setDeletingId(workerId);
//     try {
//       const response = await WorkerService.deleteWorker(workerId);
//       if (response.success) {
//         showToastNotification("success", "Worker deleted successfully");
//         const isLastRowOnPage =
//           laborList.length === 1 && paginationData.currentPage > 1;
//         if (isLastRowOnPage) {
//           setPaginationData((prev) => ({
//             ...prev,
//             currentPage: prev.currentPage - 1,
//           }));
//         } else {
//           fetchLabor(paginationData.currentPage, paginationData.pageSize);
//         }
//       } else {
//         showToastNotification(
//           "danger",
//           response.message || "Failed to delete worker",
//         );
//       }
//     } catch (error) {
//       ThrowError(error);
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   // Columns
//   const columns: TableColumn<IWorker>[] = [
//     {
//       key: "sNo",
//       header: "S.No",
//       render: (_item, index) => (
//         <span className="text-muted-foreground font-medium text-sm">
//           {(paginationData.currentPage - 1) * paginationData.pageSize +
//             index +
//             1}
//         </span>
//       ),
//     },
//     {
//       key: "workerId",
//       header: "Employee Code",
//       render: (item) => (
//         <span className="text-sm font-mono text-gray-600">{item.workerId}</span>
//       ),
//     },
//     {
//       key: "fullName",
//       header: "Name",
//       render: (item) => (
//         <div className="flex items-center gap-3">
//           <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold shadow-sm shrink-0">
//             {item.fullName?.charAt(0).toUpperCase()}
//           </div>
//           <span className="font-semibold text-gray-700">{item.fullName}</span>
//         </div>
//       ),
//     },
//     {
//       key: "phoneNumber",
//       header: "Phone",
//       render: (item) => (
//         <span className="text-gray-600">{item.phoneNumber}</span>
//       ),
//     },
//     {
//       key: "gender",
//       header: "Gender",
//       render: (item) => {
//         const g = GENDER_STYLES[item.gender] ?? GENDER_STYLES.other;
//         return (
//           <span
//             className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${g.bg} ${g.text}`}
//           >
//             <span aria-hidden="true">{g.symbol}</span>
//             {g.label}
//           </span>
//         );
//       },
//     },
//     {
//       key: "site",
//       header: "Site",
//       render: (item) => (
//         <div className="flex items-center gap-1.5 text-slate-600">
//           <MapPin size={14} className="text-emerald-500 shrink-0" />
//           <span className="text-sm font-medium">{item.Site?.siteName || "N/A"}</span>
//         </div>
//       ),
//     },
//     {
//       key: "shift",
//       header: "Shift",
//       render: (item) => {
//         const shiftName = item.Shift?.shiftName;
//         if (!shiftName) {
//           return (
//             <span className="px-2.5 py-1 bg-gray-100 text-gray-400 rounded-full text-xs font-medium">
//               --
//             </span>
//           );
//         }
//         const variant = getShiftVariant(item.shiftId || shiftName);
//         return (
//           <span
//             className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${variant.bg} ${variant.text}`}
//           >
//             <span className={`h-1.5 w-1.5 rounded-full ${variant.dot}`} />
//             {shiftName}
//           </span>
//         );
//       },
//     },
//     {
//       key: "joinDate",
//       header: "Joining Date",
//       render: (item) => (
//         <span>
//           {item.joinDate ? moment(item.joinDate).format("DD-MM-YYYY") : "N/A"}
//         </span>
//       ),
//     },
//     {
//       key: "dailyRate",
//       header: "Daily Rate",
//       render: (item) => (
//         <span className="font-medium">₹{item.dailyRate ?? 0}</span>
//       ),
//     },
//     {
//       key: "status",
//       header: "Status",
//       render: (item) => (
//         <span
//           className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide rounded-full ${
//             item.status === "active"
//               ? "text-green-600 bg-green-50"
//               : "text-red-600 bg-red-50"
//           }`}
//         >
//           <span
//             className={`h-1.5 w-1.5 rounded-full ${
//               item.status === "active" ? "bg-green-500" : "bg-red-500"
//             }`}
//           />
//           {item.status}
//         </span>
//       ),
//     },
//     {
//       key: "actions",
//       header: "Actions",
//       render: (item) => (
//         <RowActionsMenu
//           disabled={deletingId === item.id}
//           actions={[
//             {
//               label: "View",
//               icon: <Eye className="h-4 w-4" />,
//               onClick: () => navigate(`${RoutesLink.laborDetail}/${item.id}`),
//             },
//             {
//               label: "Edit",
//               icon: <Pencil className="h-4 w-4" />,
//               onClick: () => navigate(`${RoutesLink.editLabor}/${item.id}`),
//             },
//             {
//               label: "Delete",
//               icon: <Trash2 className="h-4 w-4" />,
//               onClick: () => handleDelete(item.id),
//               variant: "destructive",
//             },
//           ]}
//         />
//       ),
//     },
//   ];

//   const additionalFilters = (
//     <div className="text-left min-w-[220px]">
//       <AsyncSearchSelect
//         value={selectedSiteFilter}
//         onChange={handleSiteFilterChange}
//         loadOptions={loadSiteOptions}
//         placeholder="Filter by site…"
//       />
//     </div>
//   );

//   return (
//     <div className="space-y-6">
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//         <MainHeading
//           title="Labor Management"
//           actions={
//             <>
//               <Button
//                 variant="outline"
//                 onClick={() => navigate(RoutesLink.bulkAddLabor)}
//                 className="gap-2 border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-primary flex-1 sm:flex-none"
//               >
//                 <Upload size={16} /> Bulk Add
//               </Button>
//               <Button
//                 onClick={() => navigate(RoutesLink.createLabor)}
//                 className="gap-2 flex-1 sm:flex-none"
//               >
//                 <Plus size={16} /> Add Labor
//               </Button>
//             </>
//           }
//         />
//       </div>

//       <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
//         <CommonFilter
//           searchValue={filter.search || ""}
//           onSearchChange={handleSearchChange}
//           value={filter}
//           filterOptions={STATUS_OPTIONS}
//           filterName="status"
//           filterPlaceholder="Select Status"
//           onChange={handleFilterChange}
//           additionalFilters={additionalFilters}
//         />
//         <CommonTable
//           data={laborList}
//           columns={columns}
//           loading={isLoading}
//           stickyColumns={2}
//         />
//         <TablePagination
//           paginationData={paginationData}
//           setPaginationData={setPaginationData}
//           handleChangePageSize={handleChangePageSize}
//           isLoading={isLoading}
//         />
//       </div>
//     </div>
//   );
// };

// export default Labor;


import React, { useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import type { IFilter } from "../../components/common/CommonFilter";
import { Eye, Pencil, Plus, Trash2, Upload } from "lucide-react";
import { showToastNotification } from "../../utility/helper";
import { Button } from "../../components/ui/button";
import MainHeading from "../../components/common/MainHeading";
import CommonFilter from "../../components/common/CommonFilter";
import CommonTable, {
  type TableColumn,
} from "../../components/common/CommonTable";
import TablePagination from "../../components/common/TablePagination";
import { RoutesLink } from "../../utility/RouteLinks";
import { ThrowError } from "../../api/callApi";
import { WorkerService } from "@/services/Labor/worker";
import type { IWorker } from "@/interface/worker.model";
import AsyncSearchSelect, {
  type IOption,
} from "@/components/common/AsyncSearchSelect";
import { loadSiteOptions } from "@/hooks/Selectloaders";
import type { IPageInfo } from "@/interface/common.interface";
import RowActionsMenu from "@/components/common/RowActionsMenu";
import { ShiftBadge, GenderBadge, StatusBadge, SiteLabel, AvatarCell } from "../../components/common/Badge";

const STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

// IWorker stores gender lowercase ("male" / "female" / "other"); the shared
// GenderBadge expects a display label. This is the one place that mapping
// happens, so every other page never has to think about casing.
const genderLabel = (gender: IWorker["gender"]): string => {
  if (gender === "male") return "Male";
  if (gender === "female") return "Female";
  return "Other";
};

const Labor: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [laborList, setLaborList] = useState<IWorker[]>([]);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const [filter, setFilter] = useState<
    IFilter & { siteId?: string; shiftId?: string }
  >({
    search: "",
    status: "",
    siteId: "",
    shiftId: "",
  });

  const [selectedSiteFilter, setSelectedSiteFilter] = useState<IOption | null>(
    null,
  );

  const [paginationData, setPaginationData] = useState<IPageInfo>({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  });

  // fetch labor
  const fetchLabor = async (
    page = paginationData.currentPage,
    limit = paginationData.pageSize,
  ) => {
    setIsLoading(true);
    try {
      const response = await WorkerService.getWorkerList({
        pageIndex: page,
        pageSize: limit,
        search: filter.search || undefined,
        siteId: filter.siteId || undefined,
        shiftId: filter.shiftId || undefined,
        status: filter.status || undefined,
        sort: "createdAt",
        order: "DESC",
      });

      if (response?.success && response.data) {
        setLaborList(response.data.rows || []);
        setPaginationData((prev) => ({
          ...prev,
          total: response.data.total || 0,
          totalPages: response.data.totalPages || 0,
        }));
      } else {
        setLaborList([]);
        showToastNotification(
          "danger",
          response?.message || "Failed to load workers",
        );
      }
    } catch (error) {
      ThrowError(error);
      setLaborList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLabor(paginationData.currentPage, paginationData.pageSize);
  }, [paginationData.currentPage, paginationData.pageSize, filter]);

  const handleSearchChange = (value: string) => {
    setFilter((prev) => ({ ...prev, search: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleFilterChange = (value: string, name: string) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleSiteFilterChange = (option: IOption | null) => {
    setSelectedSiteFilter(option);
    setFilter((prev) => ({ ...prev, siteId: option?.value ?? "" }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleChangePageSize = (value: number) => {
    setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
  };

  const handleDelete = async (workerId: string) => {
    setDeletingId(workerId);
    try {
      const response = await WorkerService.deleteWorker(workerId);
      if (response.success) {
        showToastNotification("success", "Worker deleted successfully");
        const isLastRowOnPage =
          laborList.length === 1 && paginationData.currentPage > 1;
        if (isLastRowOnPage) {
          setPaginationData((prev) => ({
            ...prev,
            currentPage: prev.currentPage - 1,
          }));
        } else {
          fetchLabor(paginationData.currentPage, paginationData.pageSize);
        }
      } else {
        showToastNotification(
          "danger",
          response.message || "Failed to delete worker",
        );
      }
    } catch (error) {
      ThrowError(error);
    } finally {
      setDeletingId(null);
    }
  };

  // Columns — Gender / Shift / Site / Status all use the shared Badge
  // components so this table matches Wage Report, Attendance Report,
  // and Labour Report pixel-for-pixel.
  const columns: TableColumn<IWorker>[] = [
    {
      key: "sNo",
      header: "S.No",
      render: (_item, index) => (
        <span className="text-muted-foreground font-medium text-sm">
          {(paginationData.currentPage - 1) * paginationData.pageSize +
            index +
            1}
        </span>
      ),
    },
    {
      key: "workerId",
      header: "Employee Code",
      render: (item) => (
        <span className="text-sm font-mono text-gray-600">{item.workerId}</span>
      ),
    },
    {
      key: "fullName",
      header: "Name",
      render: (item, index) => (
        <AvatarCell
          name={item.fullName || ""}
          subLabel={item.workerId || ""}
          paletteIndex={index}
        />
      ),
    },
    {
      key: "phoneNumber",
      header: "Phone",
      render: (item) => (
        <span className="text-gray-600">{item.phoneNumber}</span>
      ),
    },
    {
      key: "gender",
      header: "Gender",
      render: (item) => <GenderBadge gender={genderLabel(item.gender)} />,
    },
    {
      key: "site",
      header: "Site",
      render: (item) => <SiteLabel label={item.Site?.siteName || "N/A"} />,
    },
    {
      key: "shift",
      header: "Shift",
      render: (item) => <ShiftBadge shift={item.Shift?.shiftName} />,
    },
    {
      key: "joinDate",
      header: "Joining Date",
      render: (item) => (
        <span>
          {item.joinDate ? moment(item.joinDate).format("DD-MM-YYYY") : "N/A"}
        </span>
      ),
    },
    {
      key: "dailyRate",
      header: "Daily Rate",
      render: (item) => (
        <span className="font-medium">₹{item.dailyRate ?? 0}</span>
      ),
    },
    {
      key: "status",
      header: "Status",
      render: (item) => (
        <StatusBadge status={item.status === "active" ? "Active" : "Inactive"} />
      ),
    },
    {
      key: "actions",
      header: "Actions",
      render: (item) => (
        <RowActionsMenu
          disabled={deletingId === item.id}
          actions={[
            {
              label: "View",
              icon: <Eye className="h-4 w-4" />,
              onClick: () => navigate(`${RoutesLink.laborDetail}/${item.id}`),
            },
            {
              label: "Edit",
              icon: <Pencil className="h-4 w-4" />,
              onClick: () => navigate(`${RoutesLink.editLabor}/${item.id}`),
            },
            {
              label: "Delete",
              icon: <Trash2 className="h-4 w-4" />,
              onClick: () => handleDelete(item.id),
              variant: "destructive",
            },
          ]}
        />
      ),
    },
  ];

  const additionalFilters = (
    <div className="text-left min-w-[220px]">
      <AsyncSearchSelect
        value={selectedSiteFilter}
        onChange={handleSiteFilterChange}
        loadOptions={loadSiteOptions}
        placeholder="Filter by site…"
      />
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <MainHeading
          title="Labor Management"
          actions={
            <>
              <Button
                variant="outline"
                onClick={() => navigate(RoutesLink.bulkAddLabor)}
                className="gap-2 border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-primary flex-1 sm:flex-none"
              >
                <Upload size={16} /> Bulk Add
              </Button>
              <Button
                onClick={() => navigate(RoutesLink.createLabor)}
                className="gap-2 flex-1 sm:flex-none"
              >
                <Plus size={16} /> Add Labor
              </Button>
            </>
          }
        />
      </div>

      <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
        <CommonFilter
          searchValue={filter.search || ""}
          onSearchChange={handleSearchChange}
          value={filter}
          filterOptions={STATUS_OPTIONS}
          filterName="status"
          filterPlaceholder="Select Status"
          onChange={handleFilterChange}
          additionalFilters={additionalFilters}
        />
        <CommonTable
          data={laborList}
          columns={columns}
          loading={isLoading}
          stickyColumns={2}
        />
        <TablePagination
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          handleChangePageSize={handleChangePageSize}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default Labor;